import Event from "./Log/Event.mjs";
import EventMail from "./Log/EventMail.mjs";
import EventIm from "./Log/EventIm.mjs";
import EventDoneStep from "./Log/EventDoneStep.mjs";
import EventStartStep from "./Log/EventStartStep.mjs";

const G = window.glob;

const m2msec = ( m ) => {
	if (typeof m === 'boolean' ) return 0;
	if (typeof m === 'string' ) m = parseInt(m);
	if ( typeof m !== 'number') return 0;
	return( m * 60000);
};
const initCopione = (copione, isReal = G.getStatus('gameIsReal') ) =>{
	if ( ! copione ) return undefined;
	if ( ! copione.steps ) return undefined;
	if ( ! Array.isArray( copione.steps )) return undefined;
	if ( ! copione.steps.length ) return undefined;
	const out = {};
	copione.steps.forEach( s => {
		const id = s.id;
		const type = s.type;
		if ( typeof out[type] === 'undefined') out[type] = {};
		out[type][id] = {};
		if ( typeof s?.maxtime === 'number' ) s.maxtime = m2msec(s.maxtime);
		if ( Array.isArray(s.hint) ) {
			const hs = {};
			s.hint.forEach( h => {
				if ( isReal) {
					h.delay = 0;
					h.auto = true;
				} else if ( typeof h?.delay === 'number' ) {
					h.delay = m2msec(h.delay);
				}
				hs[h.id] = h;
			});
			s.hint = hs;
		}
		Object.entries(s).forEach(([k,v])=>{
			switch (k) {
				case 'type': break;
				default: out[type][id][k] = v;
			}
		});
	});
	return out;
};

const initGame = ( game ) => {
	if ( ! game ) return {};
	if ( ! game?.id ) return {};
	const out = {
		id: game.id,
		name: game.name,
		lastupdate: game.lastupdate,
		real: !! game.real,
		status: game.status,
		started: {},
		done : {},
		event: [],
		mail: {},
		im: {},
		pause: 0
	};
	if ( typeof game?.creation?.time === 'number' ) {
		out.creation = new Date( game.creation.time );
		out.event.push({
			type: 'created',
			time: out.creation,
			data: game?.creation
		})
	}
	const events = Array.isArray(game.event) ? game.event : [];
	const start = events.find( e => (e.type === 'timerStarted'))?.time || game?.creation?.time || 0;
	let pauseStart = 0;
	(game.event || []).filter( e => e?.type ).forEach( e => {
		const s = {
			id: e.id ?? G.generateUid('event'),
			type: e.type,
			time : new Date(e.time),
			data : e.data || {}
		};
		if ( e.failure ) s.failure = e.failure;
		if ( out.timerStarted ) {
			s.delay = e.time - start;
			s.relativeDelay= e.time - start - out.pause;
		}
		const id = s.id;
		switch ( e.type ) {
			case 'pause' :
				pauseStart = e.time;
				break;
			case 'resume' :
				s.duration = s.data.duration ?? ( e.time - pauseStart );
				out.pause += s.duration;
				break;
			case 'startstep' :
				out.started[id] = s.data.elapsed || s.relativeDelay;
				break;
			case 'donestep' :
				out.done[id] = s.data.elapsed ?? (s.relativeDelay - out.started[id]);
				break;
			case 'injection' :
				out.done[id] = s.data.elapsed ?? s.relativeDelay;
				break;
			case 'hint' :
				out.done[id] = s.data.elapsed ?? s.relativeDelay;
				break;
			case 'timerStarted':
				out.timerStarted = true;
				out.timerRunning = true;
				break;
			case 'timerStopped':
				out.timerStopped = true;
				out.timerRunning = false;
				break;
			default:
				Object.keys( s ).forEach( k =>{
					if ( typeof e[k] === 'undefined' ) delete s[k];
				});
		}
		out.event.push(s);
	});
	( game.mail || [] ).forEach( m => { out.mail[m.id] = m; });
	( game.im || [] ).forEach( m => { out.im[m.id] = m; });
	return out;
};

const nextInjections = (copione, game ) => {
	const out = { auto:[], manual: [], free: [], nextTime: 30000 };
	if ( game?.status !== 'running') return out;
	if ( ! copione ) return out;
	const adesso = (new Date()).getTime();
	const events = game?.event || [];
	const lastEventTime = events[ events.length -1 ]?.relativeDelay || 0;
	const deltaTime = adesso - game.lastupdate;
	const done = Object.keys( game?.done || {} );
	Object.entries( copione?.injection || {} ).forEach( ([k,v])=>{
		if ( done.includes(k) ) return;
		if ( v.depends && v.depends.length ) {
			const stillPending = v.depends.find( x => ! done.includes(x));
			if ( stillPending ) return;
		}
		const nv = JSON.parse(JSON.stringify(v));
		nv.type="injection";
		if ( v.free ) out.free.push(nv);
		else if ( v.auto ) out.auto.push(nv);
		else out.manual.push(nv);
	});
	const started = game?.started || {};
	Object.entries( copione?.action || {} ).forEach( ([k,v])=>{
		if ( done.includes(k) ) return;
		const st = started[k];
		if ( typeof st !== 'number' ) return;
		if ( ! v.hint ) return;
		Object.entries( v.hint ).forEach( ([kh, vh])=> {
			if (done.includes(kh)) return;
			const elapsed = lastEventTime -st + deltaTime;
			const pendingTime = vh.delay - elapsed;
			if ( pendingTime > 0 ) {
				if ( pendingTime < out.nextTime ) out.nextTime = pendingTime;
				return;
			}
			const nvh = JSON.parse(JSON.stringify(vh));
			nvh.optional = true;
			nvh.type="hint";
			if ( vh.auto ) out.auto.push(nvh);
			else out.manual.push( nvh );
		})
	});
	return out;
};

const renderEvent = (e,opts) => {
	const pars = { event: e, options: opts };
	switch ( e.type ) {
		case 'im':
			return <EventIm {...pars} />;
		case 'mail':
			return <EventMail {...pars} />;
		case 'startstep':
			return <EventStartStep {...pars} />;
		case 'donestep':
			return <EventDoneStep {...pars} />;
		default:
			return <Event {...pars} />;
	}
}

export { m2msec, initCopione, initGame, nextInjections, renderEvent };
